export default __webpack_public_path__ + "static/media/cupon-novosel.84b46409.pdf";